/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Sign_Sign_Out_TitleInputs */

const en_common_sign_sign_out_title = /** @type {(inputs: Common_Sign_Sign_Out_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign Out`)
};

const zh_common_sign_sign_out_title = /** @type {(inputs: Common_Sign_Sign_Out_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`退出登录`)
};

/**
* | output |
* | --- |
* | "Sign Out" |
*
* @param {Common_Sign_Sign_Out_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const common_sign_sign_out_title = /** @type {((inputs?: Common_Sign_Sign_Out_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Sign_Sign_Out_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_common_sign_sign_out_title(inputs)
	return zh_common_sign_sign_out_title(inputs)
});
export { common_sign_sign_out_title as "common.sign.sign_out_title" }